import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import MaterialTable from "material-table";
import {
  MuiThemeProvider,
  createMuiTheme,
  makeStyles,
  createStyles,
} from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import { KeyboardDatePicker, KeyboardDateTimePicker } from "@material-ui/pickers";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import format from "date-fns/format";

import { initializeApp, getApps, getApp } from "firebase/app";
import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  startAfter,
  limit,
  getDoc,
  getDocs,
  onSnapshot,
  Timestamp
} from "firebase/firestore";

// import {
//   getAllAddressAPICall,
//   getAddress,
//   getZones,
//   getWards,
// } from "../../Address";

import { devicePhaseCode, deviceModeCode, serviceType, ticketStates, ticketDeviceTypes } from "../../constants/constants";

import { checkUserAccess, db, getCheckSession, getUserName, logout } from "../../apis/auth";
import DeviceAddressService from "../../apis/device-address";
import { createTicket, getAllTickets, getAllTicketsByDate, updateTicket } from "../../query/ticket.query"
import DeviceDataService from "../../apis/device-data"
import "../../styles/active-tickets.scss";
import "../../styles/reports.scss";
import { exportMaterialTableToExcel, exportMaterialTableToPDF, format2Decimals, getDateString, getDateStringHHMMSS } from "../../utilities/utility";
import { ExportCsv, ExportPdf } from "@material-table/exporters";
import AddIcon from '@material-ui/icons/Add';
import { Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Drawer, FormHelperText, List, ListItem, ListItemText, Paper, Slider, TextField, Typography } from "@material-ui/core";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { NotificationManager } from "react-notifications";
import { v4 as uuidv4 } from 'uuid';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from "@material-ui/core/Menu";
import CreateTickets from "./create-tickets";

const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
    },
    table: {
      minWidth: 650,
    },
    root: {
      width: "100%",
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      marginRight: 20,
    },
    selectMenu: {
      margin: theme.spacing(1),
      minWidth: 550,
      marginRight: 20,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    sidebar: {
      width: 100,
      borderRight: `1px solid ${theme.palette.divider}`,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    container: {
      minWidth: 150,
      display: 'flex',
    },

    selectedListItem: {
      backgroundColor: '#f0f2f4',
      color: '#1877f5',
      borderRight: '10px solid #1877f5',
    },
  })
);


const ActiveTickets = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  // const [ctDeviceType, setCtDeviceType] = useState(-1);  
  // const [ctZone, setCtZone] = useState(0);  
  // const [ctWard, setCtWard] = useState(0);  
  // const [ctDeviceID, setCtDeviceID] = useState([]);  
  // const [ctDescription, setCtDescription] = useState([]);  
  // const [ctMobile, setCtMobile] = useState([]);  
  // const [ctAssignee, setCtAssignee] = useState([]);

  const [utAssignee, setUtAssignee] = useState('');
  const [utAssigneeError, setUtAssigneeError] = useState('');
  const [comDateError, setComDateError] = useState('');
  const [comDate, setComDate] = useState(new Date());
  const [cdDate, setCdDate] = useState(new Date());
  const [utComment, setUtComment] = useState('');
  const [utCommentError, setUtCommentError] = useState('');

  const [filterObj, setFilterObj] = useState({
    deviceType: -1,
    state: -1,
    zone: 0,
    ward: 0,
    createDate: { start: null, end: null },
    resolveDate: { start: null, end: null },
    durationFilter: { start: null, end: null },
  });
  const [advanceDialogFlag, setAdvanceDialogFlag] = React.useState(false);

  const [deviceTypeList, setDeviceTypeList] = useState([]);
  const [statusTableFilterList, setStatusTableFilterList] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState([]);
  const [zoneFilterList, setZoneFilterList] = useState([]);
  const [wardFilterList, setWardFilterList] = useState([]);

  const [ticketList, setTicketList] = useState([]);
  const [historyDialog, setHistoryDialog] = useState(null);

  ///Update ticket
  const [updateTicketFlag, setUpdateTicketFlag] = React.useState(null);
  const [updateTicketData, setUpdateTicketData] = React.useState(null);

  const showUpdateTicketDialog = (state, data) => {
    setUtAssignee(data.ass);
    setUpdateTicketData(data);
    setUpdateTicketFlag(state);
    setComDate(data.com_dt?.toDate?.() || data.mt?.toDate?.() || new Date());
    setCdDate(data.ct?.toDate?.() || new Date());
  }

  const hideUpdateTicketDialog = () => {
    setUtCommentError('')
    setComDateError('')
    setUtAssigneeError('')
    setUpdateTicketFlag(null);
    setUpdateTicketData(null);
    resetUpdateTicket();
  }

  /// Create Ticket Dialog
  // const [createTicketFlag, setCreateTicketFlag] = React.useState(false);

  const showCreateTicketDialog = () => {
    history.push("/create-tickets");
    // setCreateTicketFlag(true);
  }

  // const hideCreateTicketDialog = () => {
  //   setCreateTicketFlag(false);
  // }

  /// Table Filter
  const [statusTableFilter, setStatusTableFilter] = React.useState(0);


  const handleErrorFilterChange = (event) => {
    setStatusTableFilter(event.target.value);
  };

  useEffect(async () => {
    console.log("========== Active Ticket : OnInit() ==========");
    var sessionStatus = await getCheckSession();
    var resolveTicketStatus = checkUserAccess("resolve_ticket");
    var ticketAccess = checkUserAccess("ticket");
    if (sessionStatus === false || resolveTicketStatus === false || ticketAccess === false) {
      history.push("/");
      return;
    }

    /// Status List
    let statusList = [{ label: "All", value: -1 }];
    for (const statusCode in ticketStates) {
      if (statusCode != 4) {
        statusList.push({
          label: ticketStates[statusCode],
          value: statusCode,
        });
      }
    }
    setStatusTableFilterList(statusList);

    /// Device List 
    let devList = [{ label: "All", value: -1 }];
    for (const devTypeCode in ticketDeviceTypes) {
      devList.push({
        label: ticketDeviceTypes[devTypeCode],
        value: devTypeCode,
      });
    }
    setDeviceTypeList(devList);


    /// Get zone and ward
    await DeviceAddressService.getInstance().getAllAddressAPICall();
    let zoneList = DeviceAddressService.getInstance().getZones();
    let wardList = DeviceAddressService.getInstance().getWards(zoneList[0].value);
    setZoneFilterList(zoneList);
    setWardFilterList(wardList);
    console.log(`==> Zone list ${zoneList}\n\n WardList = ${wardList}`);
    setFilterObj((prevState) => ({
      ...prevState,
      deviceType: devList[0].value,
      state: statusList[0].value,
      zone: zoneList[0].value,
      ward: wardList[0].value,
    }));

    /// Get all ticket
    await fetchTicket(0, 0, devList[0].value, [0, 1, 2, 3]);
  }, []);

  const [selectedDate, setSelectedDate] = useState({
    createDate: { start: null, end: null },
    resolveDate: { start: null, end: null },
    durationFilter: { start: null, end: null },
  });

  const handleDateChange = (date, dateField, range) => {
    if (dateField === 'createDate') {
      if (range === 'start') {
        setSelectedDate((prevState) => ({
          ...prevState,
          createDate: { start: date, end: prevState.createDate.end },
        }));

      } else {
        setSelectedDate((prevState) => ({
          ...prevState,
          createDate: { start: prevState.createDate.start, end: date },
        }));

      }
    }
    if (dateField === 'durationFilter') {
      if (range === 'start') {
        setSelectedDate((prevState) => ({
          ...prevState,
          durationFilter: { start: date, end: prevState.durationFilter.end },
        }));

      } else {
        setSelectedDate((prevState) => ({
          ...prevState,
          durationFilter: { start: prevState.durationFilter.start, end: date },
        }));

      }
    }
    if (dateField === 'resolveDate') {
      if (range === 'start') {
        setSelectedDate((prevState) => ({
          ...prevState,
          resolveDate: { start: date, end: prevState.resolveDate.end },
        }));

      } else {
        setSelectedDate((prevState) => ({
          ...prevState,
          resolveDate: { start: prevState.resolveDate.start, end: date },
        }));

      }
    }
    else {

    }
  };

  const advanceFilterFetchTicket = async (date, Flag) => {
    var stateList = [0, 1, 2, 3];
    if (filterObj.state != -1) {
      stateList = [filterObj.state];
    }
    var data = await getAllTicketsByDate(filterObj.zone, filterObj.ward, filterObj.deviceType, stateList, date.createDate, date.resolveDate, date.durationFilter, Flag).catch((e) => {
      NotificationManager.error("Unable to Complete, Your Request", "", 3000);
      console.log(e)
      return;
    });
    setAdvanceDialogFlag(false);
    setTicketList(data);
  }

  const fetchTicket = async (zone = 0, ward = 0, deviceType = -1, states = [0, 1, 2, 3]) => {
    // debugger;
    var data = await getAllTickets(zone, ward, deviceType, states).catch((e) => {
      console.log(e);
      return;
    });
    console.log("===> rec : ", JSON.stringify(data));
    // debugger;
    setTicketList(data);
  }

  const onClickApplyFilter = async () => {
    setFilterObj((prevState => ({ ...prevState, createDate: { start: null, end: null }, resolveDate: { start: null, end: null }, durationFilter: { start: null, end: null }, })))
    setDuration('')
    // debugger;
    var stateList = [0, 1, 2, 3];
    if (filterObj.state != -1) {
      stateList = [filterObj.state];
    }
    await fetchTicket(filterObj.zone, filterObj.ward, filterObj.deviceType, stateList);
  }

  const handleFilterChange = async (e) => {
    const { target: { name = "", value = "" } = {} } = e;
    if (name === "deviceType") {
      setFilterObj((prevState) => ({
        ...prevState,
        deviceType: parseInt(value),
      }));
    } else if (name === "state") {
      setFilterObj((prevState) => ({
        ...prevState,
        state: parseInt(value),
      }));
    } else if (name === "zone") {
      let wardList = DeviceAddressService.getInstance().getWards(value);
      setWardFilterList(wardList);
      setFilterObj((prevState) => ({
        ...prevState,
        zone: value,
        ward: wardList[0].value,
      }));
    } else if (name === "ward") {
      setFilterObj((prevState) => ({
        ...prevState,
        ward: value,
      }));
    }
  }

  // Update Ticket
  const onClickUpdateTicket = async () => {
    var error = false;
    const user = await getUserName().catch((error) => {
      console.error(`User name not found. error = ${error}`);
    });

    if (utAssignee == "" || utAssignee.length <= 0) {
      setUtAssigneeError("Enter user name or ID");
      error = true;
    } else {
      setUtAssigneeError("");
    }

    if (!comDate) {
      setComDateError("Select complete date and time");
      error = true;
    } else {
      setComDateError("");
    }

    if (utComment == "") {
      setUtCommentError("Enter comment");
      error = true;
    } else if (utComment.length > 500) {
      setUtCommentError("Enter comment less than 500 charectors");
      error = true;
    } else {
      setUtCommentError("");
    }

    if (error) {
      return;
    }
    var modifiedDate = Timestamp.fromDate(new Date());
    var comDate1 = Timestamp.fromDate(comDate);
    var data = {};
    data.id = updateTicketData.id;
    data.st = updateTicketFlag;
    data.ass = utAssignee;
    data.com_dt = comDate1;
    data.mt = modifiedDate;
    if (updateTicketData.history == undefined || updateTicketData.history == null) {
      updateTicketData.history = [];
    }
    data.history = updateTicketData.history;
    data.history.push({
      ct: modifiedDate,
      st: updateTicketFlag,
      ass: utAssignee,
      com: utComment,
      usr: user,
    });

    await updateTicket(data).catch((e) => {
      NotificationManager.error("Failed to update ticket.", "", 3000);
      console.log(e)
      return;
    });
    hideUpdateTicketDialog();
    NotificationManager.success("Ticket updated successfully", "", 3000);
    resetUpdateTicket();
    onClickApplyFilter();
  }

  const resetUpdateTicket = () => {
    setUtAssignee('');
    setUtAssigneeError('');
    setUtComment('');
    setUtCommentError('');
  }

  /* Contect Menu */
  const [anchorMore, setAnchorMore] = React.useState(null);
  const [actionMenu, setActionMenu] = React.useState(null);

  const handleContextMenuAction = async (event, data) => {
    console.log("row click", data);
    setAnchorMore(event.currentTarget);
    setActionMenu(data ?? null);
  }

  const handleContextMenuClose = async () => {
    setAnchorMore(null);
    setActionMenu(null);
  };
  const [actionFlag, setActionFlag] = useState(false);
  const [closeActionFlag, setCloseActionFlag] = useState(false);

  useEffect(() => {
    if (checkUserAccess("resolve_ticket")) {
      setActionFlag(true)
    }
    if (checkUserAccess("reopen_ticket")) {
      setCloseActionFlag(true)
    }
  }, [])

  const getColumnList = () => {
    return [
      {
        title: 'DATE',
        field: "ct",
        type: "datetime",
        sorting: true,

        render: ({ ct: ct = '' }) => {
          if (ct != '') {
            return format(ct.toDate(), "dd/MM/yyyy, hh:mm a");
          }
          return '';
        },
        exportTransformer: ({ ct: ct = '' }) => {
          if (ct != '') {
            return format(ct.toDate(), "dd/MM/yyyy, hh:mm a");
          }
          return '';
        },
      },
      {
        title: 'DURATION ',
        field: "ct",
        type: "datetime",
        sorting: true,
        render: ({ ct: ct = '' }) => {
          var modified = ct.toDate();
          var today = new Date();
          var difference = (today - modified) / 3600000
          if (difference < 24) {
            return "🟡"
          }
          else if (difference < 48) {
            return "🔵"
          }
          else {
            return "🔴";
          }
        },
        exportTransformer: ({ ct: ct = '' }) => {

          var modified = ct.toDate();
          var today = new Date();
          var difference = (today - modified) / 3600000

          if (difference < 24) {
            return "24 Hours"
          }
          else if (difference < 48) {
            return "48 Hours"
          }
          else {
            return "More than 48 hours";
          }
        },
      },
      {
        title: 'TICKET ID',
        field: "id",
        sorting: true,
        render: ({ id: id = "" }) => {
          return id;
        },
        exportTransformer: ({ id: id = "" }) => {
          return id;
        },
      },
      {
        title: 'DEVICE TYPE',
        field: "dt",
        sorting: true,
        render: ({ dt: dt = -1 }) => {
          if (dt == -1) {
            return "";
          }
          return ticketDeviceTypes[dt];
        },
        exportTransformer: ({ dt: dt = -1 }) => {
          if (dt == -1) {
            return "";
          }
          return ticketDeviceTypes[dt];
        },
      },
      {
        title: 'ZONE',
        field: "zn",
        sorting: true,
        render: ({ zn: zn = '' }) => {
          return zn;
        },
        exportTransformer: ({ zn: zn = '' }) => {
          return zn;
        },
      },
      {
        title: 'WARD',
        field: "wd",
        sorting: true,
        render: ({ wd: wd = '' }) => {
          return wd;
        },
        exportTransformer: ({ wd: wd = '' }) => {
          return wd;
        },
      },
      {
        title: 'STREET',
        field: "strt",
        sorting: true,
        render: ({ strt: strt = '' }) => {
          return strt;
        },
        exportTransformer: ({ strt: strt = '' }) => {
          return strt;
        },
      },
      {
        title: 'DEVICE ID',
        field: "dev_id",
        sorting: true,
        render: ({ dev_id: dev_id = 'NA' }) => {
          return dev_id;
        },
        exportTransformer: ({ dev_id: dev_id = 'NA' }) => {
          return dev_id;
        },
      },
      {
        title: 'COMPLAINT',
        sorting: false,
        render: ({ desc: desc = '' }) => {
          return desc;
        },
        exportTransformer: ({ desc: desc = '' }) => {
          return desc;
        },
      },
      {
        title: 'STATUS',
        sorting: false,
        render: ({ st: st = 0, mt = 0, com_dt }) => {
          const date = com_dt ?? mt;
          if (st === 1) {
            return ticketStates[st];
          }
          return `${ticketStates[st]}\n[${format(date.toDate(), "dd/MM/yyyy, hh:mm a")}]`;
        },
        exportTransformer: ({ st: st = 0, mt = 0, com_dt }) => {
          const date = com_dt ?? mt;
          if (st === 1) {
            return ticketStates[st];
          }
          return `${ticketStates[st]}\n[${format(date.toDate(), "dd/MM/yyyy, hh:mm a")}]`;
        },
      },
      {
        title: 'ASSIGNED TO',
        field: "ass",
        sorting: true,
        render: ({ ass: ass = "", assMob: assMob = "" }) => {
          return `${ass} - ${assMob}`;
        },
        exportTransformer: ({ ass: ass = "", assMob: assMob = "" }) => {
          return `${ass} - ${assMob}`;
        },
      },
      {
        title: 'COMPLAINANT BY',
        // field: "dev_md",
        sorting: false,
        render: ({ comNam: comNam = "", comMob: comMob = "" }) => {
          return `${comNam} - ${comMob}`;
        },
        exportTransformer: ({ comNam: comNam = "", comMob: comMob = "" }) => {
          return `${comNam} - ${comMob}`;
        },
      },
      {
        title: 'CREATED BY',
        // field: "on_time",
        sorting: false,
        render: ({ usr: usr = "" }) => {
          return usr;
        },
        exportTransformer: ({ usr: usr = "" }) => {
          return usr;
        },
      },
      {
        title: "ACTION",
        export: false,
        sorting: false,
        render: (data) => {
          return (<div>
            <IconButton aria-label="more" aria-controls="long-menu"
              aria-haspopup="true" onClick={(event) => { handleContextMenuAction(event, data) }}>
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="long-menu"
              anchorEl={anchorMore}
              keepMounted
              open={(actionMenu != null && actionMenu == data) ? true : false}
              onClose={handleContextMenuClose}
            >
              <MenuItem
                key={"Show History"}
                onClick={() => { showHistoryDialog(data); }}
              >
                {"Show History"}
              </MenuItem>

              {data.st == 0 ? (
                <MenuItem
                  key={"Update Assignee"}
                  onClick={() => { showUpdateTicketDialog(1, data); }}
                >
                  {"Update Assignee"}
                </MenuItem>
              ) : null}

              {(data.st == 1 || data.st == 3) && actionFlag ? (
                <MenuItem
                  key={"Resolve"}
                  onClick={() => { showUpdateTicketDialog(2, data); }}
                >
                  {"Resolve"}
                </MenuItem>
              ) : null}

              {(data.st == 2) && closeActionFlag ? (
                <MenuItem
                  key={"Close"}
                  onClick={() => { showUpdateTicketDialog(4, data); }}
                >
                  {"Close"}
                </MenuItem>
              ) : null}
            </Menu>
          </div>);
        }
      }
    ];
  };

  const showHistoryDialog = (data) => {
    if (data.history != undefined) {
      setHistoryDialog(data);
    }
    handleContextMenuClose();
  }

  const hideHistoryDialog = () => {
    setHistoryDialog(null);
  }

  const getHistoryColumnList = () => {
    return [
      {
        title: 'DATE',
        // field: "date",
        type: "datetime",
        render: ({ ct: ct = '' }) => {
          if (ct != '') {
            return format(ct.toDate(), "dd/MM/yyyy, hh:mm a");
          }
          return '';
        },
        exportTransformer: ({ ct: ct = '' }) => {
          if (ct != '') {
            return format(ct.toDate(), "dd/MM/yyyy, hh:mm a");
          }
          return '';
        },
      },
      {
        title: 'STATUS',
        // field: "ctr_ty",
        render: ({ st: st = 0 }) => {
          return ticketStates[st];
        },
        exportTransformer: ({ st: st = 0 }) => {
          return ticketStates[st];
        },
      },
      {
        title: 'ASSIGNED TO',
        // field: "on_time",
        render: ({ ass: ass = "" }) => {
          return ass;
        },
        exportTransformer: ({ ass: ass = "" }) => {
          return ass;
        },
      },
      {
        title: 'COMMENT',
        render: ({ com: com = '' }) => {
          return com;
        },
        exportTransformer: ({ com: com = '' }) => {
          return com;
        },
      }
    ];
  };
  const [duration, setDuration] = useState('');

  // advance dialog field variable and method
  const [selectedMenu, setSelectedMenu] = useState('createDate');

  const hideAdvanceFilterDialog = () => {
    setAdvanceDialogFlag(false);
    selectedFilter();
  };

  const selectedSidebarOption = () => {
    if (filterObj.createDate.end != null) {
      setSelectedMenu("createDate")
    }
    else if (filterObj.resolveDate.end != null) {
      setSelectedMenu("resolveDate")
    }
    else if (filterObj.durationFilter.end != null) {
      setSelectedMenu("durationFilter")
    }
    else {
      setSelectedMenu("createDate")
    }
  }

  const selectedFilter = () => {
    if (filterObj.createDate.end != null) {
      setSelectedDate((prevState) => ({
        ...prevState,
        createDate: { start: filterObj.createDate.start, end: filterObj.createDate.end },
      }));
    }
    else {
      setSelectedDate((prevState) => ({
        ...prevState,
        createDate: { start: null, end: null },
      }));
    }
    if (filterObj.durationFilter.end != null) {
      setSelectedDate((prevState) => ({
        ...prevState,
        durationFilter: { start: filterObj.durationFilter.start, end: filterObj.durationFilter.end },
      }));
    }
    else {
      setSelectedDate((prevState) => ({
        ...prevState,
        durationFilter: { start: null, end: null },
      }));
    }

    if (filterObj.resolveDate.end != null) {
      setSelectedDate((prevState) => ({
        ...prevState,
        resolveDate: { start: filterObj.resolveDate.start, end: filterObj.resolveDate.end },
      }));
    }
    else {
      setSelectedDate((prevState) => ({
        ...prevState,
        resolveDate: { start: null, end: null },
      }));
    }
  };

  const handleAdvanceFilterApply = () => {

    let startDate;
    let endDate;

    if (selectedMenu === "createDate") {
      startDate = selectedDate.createDate.start;
      endDate = selectedDate.createDate.end;
    }
    else if (selectedMenu === "durationFilter") {
      startDate = selectedDate.durationFilter.start;
      endDate = selectedDate.durationFilter.end;
    }
    else {
      startDate = selectedDate.resolveDate.start;
      endDate = selectedDate.resolveDate.end;
    }

    if (!startDate || !endDate) {
      NotificationManager.error('Please select both start and end dates', "", 3000);
      return;
    }

    if (startDate > endDate) {
      NotificationManager.error('Start date cannot be greater than end date', "", 3000);
      return;
    }
    const today = new Date();
    endDate.setHours(0, 0, 0, 0);
    today.setHours(23, 59, 59, 0);
    if (endDate > today) {
      NotificationManager.error('End date cannot be greater than today', "", 3000);
      return;
    }


    const updatedFilterObj = { ...filterObj };

    if (selectedDate.createDate.end != null) {
      if (selectedMenu === "createDate") {
        updatedFilterObj.createDate = selectedDate.createDate;
      } else {
        updatedFilterObj.createDate = { start: null, end: null };
        setSelectedDate((prevState) => ({
          ...prevState,
          createDate: { start: null, end: null },
        }));
      }
    }
    if (selectedDate.durationFilter.end != null) {
      if (selectedMenu === "durationFilter") {
        updatedFilterObj.durationFilter = selectedDate.durationFilter;
      } else {
        updatedFilterObj.durationFilter = { start: null, end: null };
        setSelectedDate((prevState) => ({
          ...prevState,
          durationFilter: { start: null, end: null },
        }));
      }
    }

    if (selectedDate.resolveDate.end != null) {
      if (selectedMenu === "resolveDate") {
        updatedFilterObj.resolveDate = selectedDate.resolveDate;
      } else {
        updatedFilterObj.resolveDate = { start: null, end: null };
        setSelectedDate((prevState) => ({
          ...prevState,
          resolveDate: { start: null, end: null },
        }));
      }
    }
    setFilterObj(updatedFilterObj);
    if (duration === "48+") {
      advanceFilterFetchTicket(updatedFilterObj, false);
      return
    }
    advanceFilterFetchTicket(updatedFilterObj, true);

  };

  const durationCalculation = (e) => {
    const selectedDuration = e.target.value;
    setDuration(selectedDuration);

    const currentDate = new Date();
    let calculatedStartDate;
    let calculatedEndDate;

    if (selectedDuration === '24') {
      calculatedStartDate = new Date(currentDate);
      calculatedStartDate.setHours(currentDate.getHours() - 24);

      calculatedEndDate = new Date(currentDate);

    } else if (selectedDuration === '48') {
      calculatedStartDate = new Date(currentDate);
      calculatedStartDate.setHours(currentDate.getHours() - 48);

      calculatedEndDate = new Date(currentDate);
      calculatedEndDate.setHours(currentDate.getHours() - 24);

    } else if (selectedDuration === '48+') {
      calculatedStartDate = new Date(currentDate);
      calculatedStartDate.setHours(currentDate.getHours() - 100);

      calculatedEndDate = new Date(currentDate);
      calculatedEndDate.setHours(currentDate.getHours() - 48);
    }
    handleDateChange(calculatedStartDate, 'durationFilter', 'start');
    if (calculatedEndDate) {
      handleDateChange(calculatedEndDate, 'durationFilter', 'end');
    }
  }

  //dialog sidebar
  const renderContent = () => {
    switch (selectedMenu) {
      case 'createDate':
        return (
          <Grid>
            <text>Create Date</text>
            <div>
              <FormControl variant="outlined" className={`${classes.formControl} filter-wrapper`}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    clearable
                    autoOk
                    label="Start Date"
                    value={selectedDate.createDate.start}
                    placeholder="dd/MM/yyyy"
                    InputAdornmentProps={{ position: 'end' }}
                    onChange={(date) => handleDateChange(date, 'createDate', "start")}
                    variant="inline"
                    inputVariant="outlined"
                    format="dd/MM/yyyy"
                  />
                </MuiPickersUtilsProvider>
              </FormControl>
              <FormControl variant="outlined" className={`${classes.formControl} filter-wrapper`}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    clearable
                    autoOk
                    label="End Date"
                    value={selectedDate.createDate.end}
                    placeholder="dd/MM/yyyy"
                    InputAdornmentProps={{ position: 'end' }}
                    onChange={(date) => handleDateChange(date, 'createDate', "end")}
                    variant="inline"
                    inputVariant="outlined"
                    format="dd/MM/yyyy"
                  />
                </MuiPickersUtilsProvider>
              </FormControl>
            </div>
          </Grid>
        );
      case 'resolveDate':
        return (
          <Grid>
            <text>
              Resolve Date
            </text>
            <div>
              <FormControl variant="outlined" className={`${classes.formControl} filter-wrapper`}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    clearable
                    autoOk
                    label="Start Date"
                    value={selectedDate.resolveDate.start}
                    placeholder="dd/MM/yyyy"
                    InputAdornmentProps={{ position: 'end' }}
                    onChange={(date) => handleDateChange(date, 'resolveDate', "start")}
                    variant="inline"
                    inputVariant="outlined"
                    format="dd/MM/yyyy"
                  />
                </MuiPickersUtilsProvider>
              </FormControl> <FormControl variant="outlined" className={`${classes.formControl} filter-wrapper`}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    clearable
                    autoOk
                    label="End Date"
                    value={selectedDate.resolveDate.end}
                    placeholder="dd/MM/yyyy"
                    InputAdornmentProps={{ position: 'end' }}
                    onChange={(date) => handleDateChange(date, 'resolveDate', "end")}
                    variant="inline"
                    inputVariant="outlined"
                    format="dd/MM/yyyy"
                  />
                </MuiPickersUtilsProvider>
              </FormControl>
            </div>
          </Grid>
        );
      case 'durationFilter':
        return (
          <Grid>
            <text>
              Duration
            </text>
            <div>
              <FormControl variant="outlined" className={`${classes.selectMenu} filter-wrapper`}>
                <InputLabel>Duration</InputLabel>
                <Select
                  value={duration}
                  onChange={durationCalculation}
                  label="Duration"
                  inputProps={{
                    name: 'duration',
                  }}
                >
                  <MenuItem value="24">24 hours</MenuItem>
                  <MenuItem value="48">48 hours</MenuItem>
                  <MenuItem value="48+">More than 48 hours</MenuItem>
                </Select>
              </FormControl>

            </div>
          </Grid>
        );
      default:
        return null;
    }
  };

  //format date
  const formatDate = (date) => {
    if (!date) return '';
    return date.toLocaleDateString();
  };

  //chip delete 
  const handleDeleteDateRange = (dateField) => {
    setFilterObj((prevState) => {
      return { ...prevState, [dateField]: { start: null, end: null } };
    });
    setDuration("")
  };

  const {
    deviceType: deviceTypeFilter = -1,
    state: stateFilter = -1,
    zone: zoneFilter = 0,
    ward: wardFilter = 0,
  } = filterObj;
  return (
    <div className="root-container reports">
      <h2 className="reports-header">Active Tickets</h2>
      <Grid container className="reports-filter-wrapper">
        <Grid xs={12} sm={12}>
          <div className="reports-zw-filter">
            {/* <Grid item> */}

            <FormControl style={{ margin: "0px 0px 0px 10px" }} variant="outlined"
              className={`${classes.formControl} filter-wrapper`}>
              <InputLabel id="zone-filter-label">Zone</InputLabel>
              <Select
                // style={{width:250}}
                labelId="zone-filter-label"
                id="zoneFilter"
                name="zone"
                value={zoneFilter}
                onChange={handleFilterChange}
                label="Zone"
              >
                {zoneFilterList.map((item) => (
                  <MenuItem key={item.value} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* </Grid> */}
            {/* Zone */}
            {/* <Grid item> */}
            <FormControl style={{ margin: "0px 0px 0px 10px" }} variant="outlined"
              className={`${classes.formControl} filter-wrapper`}>
              <InputLabel id="ward-filter-label">Ward</InputLabel>
              <Select
                // style={{width:250}}
                labelId="ward-filter-label"
                id="wardFilter"
                name="ward"
                value={wardFilter}
                onChange={handleFilterChange}
                label="Ward"
              >
                {wardFilterList.map((item) => (
                  <MenuItem value={item.value}>{item.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* </Grid> */}
            {/* Device State */}
            {/* <Grid item> */}
            <FormControl style={{ margin: "0px 0px 0px 10px" }} variant="outlined"
              className={`${classes.formControl} filter-wrapper`}>
              <InputLabel id="state-table-filter">State</InputLabel>
              <Select
                // style={{width:250}}
                labelId="state-table-filter"
                id="state-table-filter"
                name="state"
                value={stateFilter}
                onChange={handleFilterChange}
                label="State"
              >
                {statusTableFilterList.map((item) => (
                  <MenuItem key={item.value} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl style={{ margin: "0px 0px 0px 10px" }} variant="outlined"
              className={`${classes.formControl} filter-wrapper`}>
              <InputLabel id="device-filter-label">Device</InputLabel>
              <Select
                // style={{width:250}}
                labelId="device-filter-label"
                id="deviceFilter"
                name="deviceType"
                value={deviceTypeFilter}
                onChange={handleFilterChange}
                label="device"
              >
                {deviceTypeList.map((item) => (
                  <MenuItem value={item.value}>{item.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              style={{ marginLeft: '10px' }}
              color="primary" onClick={() => {
                setAdvanceDialogFlag(true)
                selectedFilter()
                selectedSidebarOption()
              }} variant="contained"
              className="ml-auto reports-apply-btn"  >
              ADVANCED
            </Button>
            <Button style={{ marginLeft: '-10px' }} color="primary" onClick={onClickApplyFilter} variant="contained"
              className="ml-auto reports-apply-btn"  >
              Filter
            </Button>

          </div>
        </Grid>
      </Grid>

      {(filterObj.resolveDate.end != null || filterObj.createDate.end != null || filterObj.durationFilter.end != null) ? <Paper
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          listStyle: 'none',
          p: 0.5,
          m: 0,
        }}
        component="ul"
      >

        <div style={{ display: 'inline-flex', flexWrap: 'wrap' }}>
          {(filterObj.createDate.start != null) ? <Chip
            key={filterObj.createDate}
            label={`Created Date ${formatDate(filterObj.createDate.start)} - ${formatDate(filterObj.createDate.end)}`}
            onDelete={() => {
              handleDeleteDateRange('createDate');
              fetchTicket();
            }}
            style={{ marginTop: 8, marginBottom: 8 }}
          /> : null}
          {(filterObj.resolveDate.start != null) ? <Chip
            key={filterObj.resolveDate}
            label={`Resolved Date ${formatDate(filterObj.resolveDate.start)} - ${formatDate(filterObj.resolveDate.end)}`}
            onDelete={() => {
              handleDeleteDateRange('resolveDate')
              fetchTicket();
            }}
            style={{ marginTop: 8, marginBottom: 8 }}
          /> : null}
          {(filterObj.durationFilter.start != null) ? <Chip
            key={filterObj.durationFilter}
            label={`Duration limit ${duration} hours `}
            onDelete={() => {
              handleDeleteDateRange('durationFilter');
              fetchTicket();
            }}
            style={{ marginTop: 8, marginBottom: 8 }}
          /> : null}
        </div>

      </Paper> : null}

      <div className="dashboard-table">
        <MaterialTable
          style={{
            margin: "20px 0",
            width: "100%",
          }}
          className={classes.table}
          title=""
          columns={getColumnList()}
          data={ticketList}
          onRowClick={(evt, rowData) => {
            console.log("row click", evt, rowData);
            // setSelectedRowData(rowData);
            // setIsErrorDialogOpen(true);
          }}
          // components={{
          //   // Container: props => props.children,
          //   // Actions: ({ data }) => <button>hello world</button>,
          //   Actions: ({ data }) => {
          //       return (
          //         <Grid container>
          //           <Grid item>
          //             <FormControl style={{ margin:"0px 0px 0px 10px"}}>
          //               <InputLabel id="zone-filter-label">Zone</InputLabel>
          //               <Select
          //               style={{width:250}}
          //                 labelId="zone-filter-label"
          //                 id="zoneFilter"
          //                 name="zone"
          //                 value={zoneFilter}
          //                 onChange={handleFilterChange}
          //                 label="Zone"
          //               >
          //                 {zoneFilterList.map((item) => (
          //                   <MenuItem key={item.value} value={item.value}>
          //                     {item.label}
          //                   </MenuItem>
          //                 ))}
          //               </Select>
          //             </FormControl>
          //           </Grid>
          //           {/* Zone */}
          //           <Grid item>
          //             <FormControl style={{ margin:"0px 0px 0px 10px"}}>
          //             <InputLabel id="ward-filter-label">Ward</InputLabel>
          //             <Select
          //             style={{width:250}}
          //               labelId="ward-filter-label"
          //               id="wardFilter"
          //               name="ward"
          //               value={wardFilter}
          //               onChange={handleFilterChange}
          //               label="Ward"
          //             >
          //               {wardFilterList.map((item) => (
          //                 <MenuItem value={item.value}>{item.label}</MenuItem>
          //               ))}
          //             </Select>
          //             </FormControl>
          //           </Grid>
          //           {/* Device State */}
          //           <Grid item>
          //           <FormControl style={{ margin:"0px 0px 0px 10px"}}>
          //             <InputLabel id="state-table-filter">State</InputLabel>
          //           <Select
          //             style={{width:250}}
          //               labelId="state-table-filter"
          //               id="state-table-filter"
          //               name="state"
          //               value={stateFilter}
          //               onChange={handleFilterChange}
          //             >
          //               {statusTableFilterList.map((item) => (
          //                 <MenuItem key={item.value} value={item.value}>
          //                   {item.label}
          //                 </MenuItem>
          //               ))}
          //             </Select>
          //             </FormControl>
          //           </Grid>
          //           {/* Device Type */}
          //           <Grid item>
          //             <FormControl style={{ margin:"0px 0px 0px 10px"}}>
          //             <InputLabel id="device-filter-label">Device</InputLabel>
          //             <Select
          //             style={{width:250}}
          //               labelId="device-filter-label"
          //               id="deviceFilter"
          //               name="deviceType"
          //               value={deviceTypeFilter}
          //               onChange={handleFilterChange}
          //               label="device"
          //             >
          //               {deviceTypeList.map((item) => (
          //                 <MenuItem value={item.value}>{item.label}</MenuItem>
          //               ))}
          //             </Select>
          //             </FormControl>
          //           </Grid>
          //           {/* Apply Filter */}
          //           <Grid item>
          //             <Button color="primary" onClick={onClickApplyFilter}  variant="contained" style={{marginLeft:10, marginTop:10}}>
          //               Filter
          //             </Button>
          //           </Grid>
          //           {/* Create Ticket */}
          //           {/* <Grid item>
          //             <Button color="primary" onClick={showCreateTicketDialog}  variant="contained" style={{marginLeft:20, marginTop:10}}>
          //               Create Ticket
          //             </Button>
          //           </Grid> */}
          //         </Grid>
          //       )
          //   }
          // }}
          options={{
            exportButton: true,
            exportAllData: true,
            exportCsv: (columns, csvData) => { exportMaterialTableToExcel(columns, csvData, `Active_Tickets-${getDateString()}`); },
            exportPdf: (columns, csvData) => { exportMaterialTableToPDF(columns, csvData, `Active_Tickets-${getDateString()}`, 8, 18); },
            // exportCsv: (columns, data) => ExportCsv(columns.filter(item=> item.export === undefined || item.export === true), data, `Energy Saving Report-${getDateString(filterObj.startDate)}`,","),
            // exportPdf: (columns, data) => ExportPdf(columns.filter(item=> item.export === undefined || item.export === true), data, `Energy Saving Report-${getDateString(filterObj.startDate)}`),
            // grouping: true,
            search: true,
            selection: false,
            sorting: true,
            pageSize: 10,
            // rowStyle: (rowData) => ({
            //   backgroundColor:
            //     rowData?.ccmsNumber === selectedRowData?.ccmsNumber
            //       ? "#f0f2f4"
            //       : "",
            // }),
            headerStyle: {
              backgroundColor: "#0071CE",
              color: "#FFF",
              fontSize: "0.9em",
              textAlign: "center",
            },
            actionsColumnIndex: -1,
            emptyRowsWhenPaging: false,
          }}
          localization={{
            toolbar: {
              searchPlaceholder: "Search",
              exportCSVName: "Export as Excel",
              exportPDFName: "Export as PDF",
            },
          }}
        />
      </div>
      {/* Create ticket dialog */}
      {/* <Dialog className="create-ticket-dialog" open={createTicketFlag} onClose={hideCreateTicketDialog} aria-labelledby="form-dialog-title" fullScreen={fullScreen} fullWidth maxWidth={'md'}>
        {/* <DialogTitle id="form-dialog-title">Create Ticket</DialogTitle> * /}
        <DialogContent>
          <CreateTickets />
          {/* <DialogContentText>
            To subscribe to this website, please enter your email address here. We will send updates
            occasionally.
          </DialogContentText> */}
      {/* <FormControl className="dialog-form" style={{width:'100%', margin:'10px 0'}}>
            {/* Device Type * /}
            <InputLabel id="device-type-label">Device Type</InputLabel>
            <Select
              required
              labelId="device-type-label"
              id="device-type-label"
              name="deviceType"
              value={ctDeviceType}
              onChange={handleFilterChange}
              label="Device Type"
              
            >
              {/* <MenuItem value={"all"}>All</MenuItem> * /}
              {deviceTypeList.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
            </FormControl>
          <FormControl className="dialog-form" style={{width:'100%', margin:'10px 0'}}>
            {/* Zone * /}
            <InputLabel id="zone-label">Zone</InputLabel>
            <Select
              labelId="zone-label"
              id="zone"
              name="zone"
              value={ctZone}
              onChange={handleFilterChange}
              label="Zone"
            >
              {zoneFilterList.map((item) => (
                <MenuItem key={item.value} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
            </FormControl>
            {/* Ward * /}
            <FormControl className="dialog-form" style={{width:'100%', margin:'10px 0'}}>
              <InputLabel id="ward-label">Ward</InputLabel>
              <Select
                labelId="ward-label"
                id="ward"
                name="ward"
                value={ctWard}
                onChange={handleFilterChange}
                label="Ward"
              >
                {wardFilterList.map((item) => (
                  <MenuItem value={item.value}>{item.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl className="dialog-form" style={{width:'100%', margin:'0px 0'}}>
              <TextField
                autoFocus
                margin="dense"
                id="deviceId"
                label="Device ID"
                type="text"
                value={ctDeviceID}
                onChange={(e)=> {
                  setCtDeviceID(e.target.value);
                }}
              />
          </FormControl>
          <FormControl className="dialog-form" style={{width:'100%', margin:'10px 0'}}>
          <label className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiFormLabel-filled">Complaint</label>
          </FormControl>
          <FormControl className="dialog-form" style={{width:'100%', margin:'10px 0px 0px 0px'}}>
            <TextareaAutosize
            labelId="complaint-label"
            label="Complaint"
            minRows={5}s
            maxRows={5}
            aria-label="Complaint"
            placeholder="Maximum 500 charectors"
            value={ctDescription}
            onChange={(e)=> {
              setCtDescription(e.target.value);
            }}
            />
          </FormControl>
          <FormControl className="dialog-form" style={{width:'100%', margin:'0px 0'}}>
              <TextField
                autoFocus
                margin="dense"
                id="mobile"
                label="Mobile"
                type="text"
                value={ctMobile}
                onChange={(e)=> {
                  setCtMobile(e.target.value);
                }}
              />
          </FormControl>
          <FormControl className="dialog-form" style={{width:'100%', margin:'10px 0'}}>
              <TextField
                autoFocus
                margin="dense"
                id="assignee"
                label="Assigned to"
                type="text"
                value={ctAssignee}
                onChange={(e)=> {
                  setCtAssignee(e.target.value);
                }}
              />
          </FormControl> * /}
        </DialogContent>
        {/* <DialogActions>
          <Button onClick={hideCreateTicketDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={onClickCreateTicket} color="primary">
            Create
          </Button>
        </DialogActions> * /}
      </Dialog> */}

      {/* Update State dialog */}
      <Dialog className="update-ticket-dialog" open={updateTicketFlag != null} onClose={hideUpdateTicketDialog} aria-labelledby="form-dialog-title" fullScreen={fullScreen} fullWidth maxWidth={'md'}>
        <DialogTitle id="form-dialog-title">Update State</DialogTitle>
        <DialogContent>
          <FormControl className="dialog-form" style={{ width: '100%', margin: '0px 0' }}>
            <TextField
              autoFocus
              margin="dense"
              id="status"
              label="Status"
              type="text"
              value={ticketStates[updateTicketFlag]}
            />
          </FormControl>

          <FormControl className="dialog-form" style={{ width: '100%', margin: '10px 0' }}>
            <TextField
              error={utAssigneeError.length > 0 ? true : false}
              helperText={utAssigneeError}
              autoFocus
              margin="dense"
              id="assignee"
              label="Assigned to"
              type="text"
              value={utAssignee}
              onChange={(e) => {
                setUtAssignee(e.target.value);
              }}
            />
          </FormControl>
          <FormControl variant="outlined" fullWidth>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDateTimePicker
                margin="dense"
                id="completion-date"
                label="Complete Date & Time"
                disableFuture
                value={comDate}
                onChange={(date) => setComDate(date)}
                format="MM/dd/yyyy HH:mm"
                minDate={cdDate}
                helperText={comDateError}
                error={comDateError.length > 0}
              />
            </MuiPickersUtilsProvider>
          </FormControl>
          <FormControl className="dialog-form" style={{ width: '100%', margin: '10px 0' }}>
            <label className="MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated MuiInputLabel-shrink MuiFormLabel-filled">COMMENT</label>
          </FormControl>

          <FormControl className="dialog-form" style={{ width: '100%', margin: '10px 0px 0px 0px' }}>
            <TextareaAutosize
              labelId="comment-label"
              label="Comment"
              minRows={5}
              maxRows={5}
              aria-label="Comment"
              placeholder="Maximum 500 characters"
              value={utComment}
              onChange={(e) => {
                setUtComment(e.target.value);
              }}
            />
            <FormHelperText className="Mui-error">{utCommentError}</FormHelperText>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={hideUpdateTicketDialog} color="primary">
            Cancel
          </Button>
          <Button onClick={onClickUpdateTicket} color="primary">
            Update
          </Button>
        </DialogActions>
      </Dialog>

      {/* Advance Filter Dialog */}
      <Dialog
        className="update-ticket-dialog"
        open={advanceDialogFlag}
        onClose={hideAdvanceFilterDialog}
        aria-labelledby="form-dialog-title"
        fullWidth
        maxWidth="md"
      >
        <DialogTitle id="form-dialog-title">Advanced Filter</DialogTitle>
        <div className={classes.container}>
          <DialogContent className={classes.sidebar}>
            <List >
              <ListItem
                button
                className={`${selectedMenu === 'createDate' ? classes.selectedListItem : ''}`}
                onClick={() => {
                  setSelectedMenu('createDate');
                  selectedFilter();
                }}>
                <ListItemText primary="Create Date" />
              </ListItem>
              <ListItem
                button
                className={` ${selectedMenu === 'resolveDate' ? classes.selectedListItem : ''}`}
                onClick={() => {
                  setSelectedMenu('resolveDate')
                  selectedFilter();
                }}>
                <ListItemText primary="Resolve Date" />
              </ListItem>
              <ListItem
                button
                className={` ${selectedMenu === 'durationFilter' ? classes.selectedListItem : ''}`}
                onClick={() => {
                  setSelectedMenu('durationFilter')
                  selectedFilter();
                }}>
                <ListItemText primary="Duration Filter" />
              </ListItem>
            </List>
          </DialogContent>
          <DialogContent className={classes.content}>
            {renderContent()}
          </DialogContent>
        </div>
        <DialogActions>
          <Button onClick={() => {
            hideAdvanceFilterDialog()
          }} color="primary">
            Cancel
          </Button>
          <Button onClick={() => {
            // if (startDate > endDate) {
            //   NotificationManager.error("Please select valid date", "", 3000);
            //   return;
            // }
            handleAdvanceFilterApply();
          }} color="primary">
            Apply
          </Button>
        </DialogActions>
      </Dialog>
      {/* History Dialog */}
      <Dialog className="history-dialog" open={historyDialog != null} onClose={hideHistoryDialog} aria-labelledby="form-dialog-title" fullScreen={fullScreen} fullWidth maxWidth={'md'}>
        <DialogTitle id="form-dialog-title">Ticket History </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {historyDialog?.desc}
          </DialogContentText>
          <MaterialTable
            style={{
              margin: "20px 0",
              width: "100%",
            }}
            className={classes.table}
            title={`ID: ${historyDialog?.id}`}
            columns={getHistoryColumnList()}
            data={historyDialog?.history ?? []}
            // onRowClick={(evt, rowData) => {
            //   console.log("row click", evt, rowData);
            //   // setSelectedRowData(rowData);
            //   // setIsErrorDialogOpen(true);
            // }}

            options={{
              exportButton: false,
              // exportAllData:true,
              // exportCsv:(columns, csvData) => {exportMaterialTableToExcel(columns, csvData, `Ticket_History-${getDateString()}`);},
              // exportPdf:(columns, csvData) => {exportMaterialTableToPDF(columns, csvData, `Ticket_History-${getDateString()}`, 8, 18);},
              // exportCsv: (columns, data) => ExportCsv(columns.filter(item=> item.export === undefined || item.export === true), data, `Energy Saving Report-${getDateString(filterObj.startDate)}`,","),
              // exportPdf: (columns, data) => ExportPdf(columns.filter(item=> item.export === undefined || item.export === true), data, `Energy Saving Report-${getDateString(filterObj.startDate)}`),
              // grouping: true,
              search: false,
              selection: false,
              sorting: false,
              pageSize: 5,
              // rowStyle: (rowData) => ({
              //   backgroundColor:
              //     rowData?.ccmsNumber === selectedRowData?.ccmsNumber
              //       ? "#f0f2f4"
              //       : "",
              // }),
              headerStyle: {
                backgroundColor: "#0071CE",
                color: "#FFF",
                fontSize: "0.9em",
                textAlign: "center",
              },
              actionsColumnIndex: -1,
              emptyRowsWhenPaging: false,
            }}
            localization={{
              toolbar: {
                searchPlaceholder: "Search",
                exportCSVName: "Export as Excel",
                exportPDFName: "Export as PDF",
              },
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={hideHistoryDialog} color="primary">
            CLOSE
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default ActiveTickets;
